import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { makeBibJacketCoverAltText } from 'app/helpers/bib/bibHelpers';
import { bibShape } from '@bibliocommons/bc-prop-types';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { bindAll } from '@bibliocommons/utils-react';

import SearchAnalyticsContext from 'app/components/search/SearchAnalyticsContext';
import SearchResultItemContent from '../SearchResultItemContent';

import './SearchResultItem.scss';

// These props are used in SearchResultItemContent
/* eslint-disable react/no-unused-prop-types */
const propTypes = {
  item: ImmutablePropTypes.map,
  itemPosition: PropTypes.number,
  itemRecommendations: ImmutablePropTypes.map,
  branches: ImmutablePropTypes.list,
  manifestations: ImmutablePropTypes.listOf(bibShape),
  showJacketCover: PropTypes.bool,
  showSeries: PropTypes.bool,
  order: PropTypes.number,
  dataKey: PropTypes.string,
  renderCards: PropTypes.func
};
/* eslint-enable react/no-unused-prop-types */

export class SearchResultItem extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleJacketClick() {
    const { item: bib, itemPosition, manifestations } = this.props;
    const totalCount = manifestations.count();

    const { trackBibJacketClick } = this.context;

    trackBibJacketClick({ bib, itemPosition, itemPositionGrouped: 0, totalCount });
  }

  render() {
    const { item, showJacketCover, showSeries, renderCards } = this.props;
    const jacketSource = item.getIn(['briefInfo', 'jacket']);
    const bibCoverAltText = makeBibJacketCoverAltText(
      item.getIn(['briefInfo', 'title']),
      item.getIn(['briefInfo', 'authors'])
    );

    const jacketBlock = (
      <div className="col-md-2 visible-md visible-lg item-column">
        <a
          href={`/v2/record/${item.get('id')}`}
          onClick={this.handleJacketClick}
          tabIndex="-1"
          aria-hidden="true"
          target="_parent"
          data-key="bib-image-link"
        >
          <JacketCover
            src={jacketSource}
            format={item.getIn(['briefInfo', 'format'])}
            alt={bibCoverAltText}
            responsive
            variant="search"
          />
        </a>
      </div>
    );

    const itemClass = showJacketCover ? 'col-md-10' : 'col-md-12';
    return (
      <li
        className="row cp-search-result-item"
        data-test-id="searchResultItem"
        style={{ order: this.props.order }}
        data-key={this.props.dataKey}
      >
        {showJacketCover ? jacketBlock : null}
        <div className={`${itemClass} item-column`}>
          <SearchResultItemContent
            {...this.props}
            showSeries={showSeries}
            id={item.get('id')}
            showJacketCover={showJacketCover}
            trackJacketClick={this.handleJacketClick}
          />
          {renderCards && renderCards()}
        </div>
      </li>
    );
  }
}

SearchResultItem.contextType = SearchAnalyticsContext;

SearchResultItem.propTypes = propTypes;
SearchResultItem.defaultProps = {
  order: 0
};

export default SearchResultItem;
